'use client'
import React, { Component, useEffect, useState } from 'react';
import styled from 'styled-components';
import { Container, Row, Col } from 'react-bootstrap';
import Link from "next/link";
import parser from "html-react-parser";

const Address = ({ top, posts,data }) => {

    return (
        <StyleAddress top={top} className={'pt-100 pb-100'}>
            <Container>
                <Row>
                    <Col sm={data?.operating_hour ? 3 : 4}>
                        <div className={'office'}>
                            <h4>Corporate Office</h4>
                            <p><Link href={data?.gmap_corporate} target={'_blank'}>{data?.title}</Link></p>
                        </div>
                    </Col>
                    {
                        data?.operating_hour &&
                        <Col sm={3}>
                            <div className={'office'}>
                                <h4>Registered Office</h4>
                                <p><Link href={data?.gmap_registered} target={'_blank'}>{data?.operating_hour}</Link></p>
                            </div>
                        </Col>
                    }

                    <Col sm={4} >
                        <div className={'office'}>
                            <h4>Call Us</h4>
                            {
                                parser(data?.phone)
                            }
                        </div>
                    </Col>
                    <Col sm={4}>
                        <div className={'office'}>
                            <h4>Email</h4>
                            {
                                parser(data?.email)
                            }
                        </div>
                    </Col>
                </Row>
            </Container>
        </StyleAddress>
    )
}
const StyleAddress = styled.section`
    background-color: #F9F9F9;
    .address-flex{
        gap: 15px;
    }
    h5{
        margin-bottom: 10px;
    }
    h4 {
        margin-bottom: 20px;
    }

    a {
        color: black;
    }

    .office {
        padding-bottom: 20px;
        border-bottom: 1px solid rgba(0, 0, 0, 0.2);
        height: 100%;
    }

    @media (max-width: 767px) {
        .col-sm-3 {
            margin-bottom: 30px;
        }
    }


`;
export default Address;
